import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { FONT, JapaneseA4DividerPositions } from '../../../types/enums';
import { getFontFamily } from '../utils';

interface Props {
  position: JapaneseA4DividerPositions;
}

export const JapaneseA4Divider: React.FC<Props> = ({ position }) => {

  const getDividerPositionStyles = () => {
    if (position === JapaneseA4DividerPositions.BOTTOM) {
      return {
        bottom: '-55%',
        left: '49.5%'
      };
    }
    if (position === JapaneseA4DividerPositions.TOP) {
      return {
        top: '48%',
        left: '49.5%'
      };
    }
    if (position === JapaneseA4DividerPositions.RIGHT) {
      return {
        top: '99%',
        right: '22%'
      };
    }
    if (position === JapaneseA4DividerPositions.LEFT) {
      return {
        top: '99%',
        left: '24%'
      };
    }
  };

  const textStyles = [getFontFamily('山折り', { fallbackFont: FONT.HELVETICA }), {
    color: '#696969',
    fontSize: '6px',
    lineHeight: '1.2'
  }];

  return (
    <View style={{
      position: 'absolute',
      width: '25px',
      ...getDividerPositionStyles()
    }}>
      {
        (position === JapaneseA4DividerPositions.LEFT || position === JapaneseA4DividerPositions.RIGHT) ?
        <Text style={textStyles}>山折り</Text> : (
          <View>
            <Text style={textStyles}>山</Text>
            <Text style={textStyles}>折</Text>
            <Text style={textStyles}>り</Text>
          </View>
        )
      }
    </View>
  );
};
